import React, { useContext, useEffect, useState } from 'react'
import { BottomDiv, ButtonContainer, ButtonDiv, CloseDiv, Container, FormData, Header, InputData, InputDiv, InputLabel } from './style'
import close from '../../../assets/close-icon.svg'
import ModalContext from '../../../contexts/ModalContext'
import { fieldsAndValues } from './utils'
import plus from '../../../assets/productions/plus.svg'
import disk from '../../../assets/productions/disk.svg'
import axios from 'axios'
import { ProductionUserContext } from '../../../contexts/ProductionUser'

interface FormDataType {
  fullName: string
  position: string
  costPerHour: string | any
  costPerExtraHour: string | any
  machines: string
}

const CreateUserModal:React.FC = () => {
  const { setModalActive, modalSection } = useContext(ModalContext)
  const { productionUser } = useContext(ProductionUserContext)
  const [incorrectData, setIncorrectData] = useState<boolean>(false)
  const [formData, setFormData] = useState<FormDataType>({
    fullName: '',
    position: '',
    costPerHour: '',
    costPerExtraHour: '',
    machines: '',
  })
  
  useEffect(() => {
    if (modalSection === 'editUser') {
      const filteredUserData = Object.keys(formData).reduce((acc, key) => {
        const typedKey = key as keyof FormDataType
        if (productionUser[typedKey] !== undefined) {
          acc[typedKey] = productionUser[typedKey]
        }
        return acc
      }, {} as Partial<FormDataType>)
  
      setFormData((prevFormData) => ({
        ...prevFormData,
        ...filteredUserData,
      }))
    }
  }, [productionUser])
  

  const formatCurrency = (value: string) => {
    value = value.replace(/\D/g, '')

    const cents = value.slice(-2) || '00'
    const integerPart = value.slice(0, -2) || '0'

    return `${parseInt(integerPart, 10)},${cents.padStart(2, '0')}`
  }

  const handleInputChange = (value: string, field: string) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value
    }))
  }

  const handleSubmit = async () => {
    for (const key in formData) {
      const typedKey = key as keyof FormDataType
      if (formData[typedKey].length < 1) {
        setIncorrectData(true)
        return
      }
    }    
    setIncorrectData(false)
  
    const formattedData = {
      ...formData,
      costPerHour: Number(formData.costPerHour.replace(',', '.')),
      costPerExtraHour: Number(formData.costPerExtraHour.replace(',', '.')),
    }
  
    try {
      if(modalSection === 'createUser'){
        await axios.post(`${process.env.REACT_APP_PRODUCTION_FLOW_BASE_URL}/production-user`, formattedData)
      }else{
        await axios.patch(`${process.env.REACT_APP_PRODUCTION_FLOW_BASE_URL}/production-user/${productionUser.id}`, formattedData)
      }
    } catch (error) {
      console.error(error)
    }
  }  

  return(
    <Container>
      <Header>
        <h2>{modalSection === 'editUser' ? `Editar usuário: ${productionUser.fullName}` : 'Cadastrar usuário'}</h2>
        <CloseDiv onClick={() => (setModalActive(false))}>
          <img src={close} />
        </CloseDiv>
      </Header>
      <FormData>
        {fieldsAndValues.map((item, index) => (
          <InputDiv key={index}>
            <InputLabel>{item.label}</InputLabel>
            <InputData
              placeholder={item.placeholder ? item.placeholder : 'Digite aqui'}
              type={item.type === 'cash' ? 'text' : item.type}
              onChange={(event) => {
                let value = event.target.value
                if (item.type === 'cash') {
                  value = formatCurrency(value)
                }
                handleInputChange(value, item.value)
                event.target.value = value
              }}
              value={formData[item.value as keyof typeof formData]}
            />
          </InputDiv>
        ))}
      </FormData>
      <BottomDiv>
        <span>{incorrectData === true && <>Preencha todos os campos</>}</span>
        <ButtonContainer>
          <ButtonDiv onClick={() => setModalActive(false)} className='cancel'>Cancelar</ButtonDiv>
          <ButtonDiv onClick={() => handleSubmit()}>
            <img src={modalSection === 'createUser' ? plus : disk} /> 
            {modalSection === 'createUser' ? 'Cadastrar' : 'Salvar alterações'}
          </ButtonDiv>
        </ButtonContainer>
      </BottomDiv>
    </Container>
  )
}

export default CreateUserModal
